import React, { Component } from 'react';
import styles from "./styles.scss";
import { bool, string } from 'prop-types';

export default class CompilationTooltip extends Component {
  static propTypes = {
    header: string,
    headerKey: string,
    subheader: string,
    totalValueLabel: string,
    baseValueLabel: string,
    additionalValueLabel: string,
    guidelineValueLabel: string,
    totalValueKey: string,
    baseValueKey: string,
    additionalValueKey: string,
    guidelineValueKey: string,
    baseIndicatorColor: string,
    additionalIndicatorColor: string,
    showBaseOption: bool,
    guidelineIndicatorColor: string
  }

  static defaultProps = {
    showBaseOption: true,
    baseIndicatorColor: '#00BCD4',
    additionalIndicatorColor: '#3F51B5',
    guidelineIndicatorColor: '#CF87DF'
  }

  render() {
    const {
      header,
      headerKey,
      subheader,
      totalValueKey,
      totalValueLabel,
      baseValueKey,
      baseValueLabel,
      baseIndicatorColor,
      additionalValueKey,
      additionalValueLabel,
      additionalIndicatorColor,
      guidelineValueKey,
      guidelineValueLabel,
      showBaseOption,
      guidelineIndicatorColor
    } = this.props;

    return (
      <div className={styles.compilationChartTooltip}>
        {
          (header || headerKey) && <div className={styles.header}>{header || `{${headerKey}}`}</div>
        }
        {
          (header || headerKey) && <hr className={styles.divider} />
        }
        {
          subheader && <div className={styles.subheader}>{subheader}</div>
        }
        {
          showBaseOption && totalValueKey && 
          <div className={styles.totalValue}>
            <div className={styles.label}>{totalValueLabel}</div>
            <div>{`{${totalValueKey}}`}</div>
          </div>
        }
        {
          showBaseOption && baseValueKey &&
          <div className={styles.baseValue}>
            <div className={styles.indicator} style={{backgroundColor: baseIndicatorColor}} />
            <div className={styles.label}>{baseValueLabel}</div>
            <div>{`{${baseValueKey}}`}</div>
          </div>
        }
        {
          additionalValueKey &&
          <div className={styles.additionalValue}>
            <div className={styles.indicator} style={{backgroundColor: additionalIndicatorColor}}/>
            <div className={styles.label}>{additionalValueLabel}</div>
            <div>{`{${additionalValueKey}}`}</div>
          </div>
        }
        {
          guidelineValueKey &&
          <div className={styles.guidelineValue}>
            <div className={styles.indicator} style={{backgroundColor: guidelineIndicatorColor}} />
            <div className={styles.label}>{guidelineValueLabel}</div>
            <div>{`{${guidelineValueKey}}`}</div>
          </div>
        }
        <div className={styles.shownMessage}>Shown in station local time</div>
      </div>
    );
  }
}